import { render, staticRenderFns } from "./SettingOwnerInfo.vue?vue&type=template&id=592c4f33&"
import script from "./SettingOwnerInfo.vue?vue&type=script&lang=js&"
export * from "./SettingOwnerInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports